var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-orange",on:{"click":_vm.submit}},[_vm._t("default",function(){return [_c('span',[_vm._v("Load More")])]}),(_vm.loading)?_c('span',{staticClass:"rml50"},[_c('i',{staticClass:"fas fa-spinner rotate"})]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }